module.exports = __webpack_public_path__ + "img/Logo.d99aada8.svg";